<script setup>
import { ref } from 'vue';

import { useStore } from '@/store';

const emit = defineEmits(['submit', 'setQuery', 'remove']);

const props = defineProps({
    query: {
        type: String,
        required: true,
    },
    leadingIcon: {
        type: String,
    },
    hideSetQuery: {
        type: Boolean,
        default: false,
    },
    showRemove: {
        type: Boolean,
        default: false,
    },
});

const store = useStore();
const hovered = ref(false);

const onPress = (e) => {
    if (store.state.deviceType === 'desktop' || !props.showRemove) {
        return;
    }

    e.preventDefault();
    e.srcEvent.stopPropagation();

    confirm({
        title: `Remove from history?`,
        description: `Remove ${props.query} from your search history`,
    }).then(() => {
        emit('remove');
    }).catch(() => {
        //
    });
}
</script>
<template>
    <div class="flex items-center hover:bg-white-foreground/10" @mouseover="hovered = true" @mouseleave="hovered = false">
        <button type="button"
            v-hammer:press="onPress"
            :aria-label="`Search for ${query}`"
            class="flex items-center gap-2 grow px-4 py-2 min-w-0 min-h-12"
            @click="$emit('submit')"
        >
            <component :is="`icon-${leadingIcon}`" v-if="leadingIcon" class="size-6 shrink-0" />
            <span class="truncate">{{ query }}</span>
            <button v-if="showRemove && hovered && $store.state.deviceType === 'desktop'"
                type="button"
                @click.prevent.stop="$emit('remove')"
                class="ml-auto hover:bg-white-foreground/10 rounded-full flex items-center justify-center p-1">
                <icon-cancel class="size-6" />
            </button>
        </button>
        <button
            v-if="!hideSetQuery"
            type="button"
            class="flex items-center shrink-0 p-1 mr-2 hover:bg-white-foreground/10 rounded-full"
            aria-label="Replace search"
            @click="$emit('setQuery')"
        >
            <icon-arrow-top-right class="size-6" />
        </button>
    </div>
</template>

